import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @repo/internal/react/no-class-components */

/* There is no good way to replace ErrorBoundary class components with a
 * functional component; currently no functional hook that can replace
 * 'componentDidCatch'.
 * Source: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * But I needed to get 'createAnalyticsEvent' via a hook hence
 * the wrapped class component.
 */

import React from 'react';
import { useIntl } from 'react-intl-next';
import { markdownConversionErrorName } from '../../../ui/MarkdownConversionError';
import { useFireAIAnalyticsEvent } from '../../../analytics/utils';
import { UnhandledErrorScreen } from '@atlassian/generative-ai-modal/screens/UnhandledError';
import errorMessages from './messages';
import { ErrorUtils } from '../../../utils/errors';
export const ModalRegionErrorBoundary = props => {
  const fireAIAnalyticsEvent = useFireAIAnalyticsEvent();
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(ExperienceApplicationErrorBoundaryClass, _extends({}, props, {
    fireAIAnalyticsEvent: fireAIAnalyticsEvent,
    formatMessage: formatMessage
  }));
};
class ExperienceApplicationErrorBoundaryClass extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getFallbackMessage", descriptor => {
      return this.props.formatMessage(descriptor);
    });
    _defineProperty(this, "state", {
      errorCaptured: false,
      fallbackMessage: this.getFallbackMessage(errorMessages.unhandledErrorMessage)
    });
  }
  shouldRecover() {
    return this.state.errorCaptured;
  }
  componentDidCatch(error, errorInfo) {
    if (error.name === markdownConversionErrorName) {
      const errorHasTypeProperty = ('type' in error);
      const errorSubType = errorHasTypeProperty ? error.type : undefined;
      this.props.fireAIAnalyticsEvent({
        payload: {
          action: 'unhandledErrorCaught',
          actionSubject: 'editorPluginAI',
          actionSubjectId: 'experienceApplication',
          attributes: {
            componentStack: errorInfo.componentStack,
            errorType: 'markdownToProseMirrorError',
            errorSubType,
            errorMessage: ErrorUtils.extractErrorMessage(error)
          },
          eventType: 'operational'
        }
      });
      this.setState({
        errorCaptured: true,
        fallbackMessage: this.getFallbackMessage(errorMessages.markdownErrorMessage)
      });
    } else {
      this.props.fireAIAnalyticsEvent({
        payload: {
          action: 'unhandledErrorCaught',
          actionSubject: 'editorPluginAI',
          actionSubjectId: 'experienceApplication',
          attributes: {
            componentStack: errorInfo.componentStack,
            errorMessage: ErrorUtils.extractErrorMessage(error)
          },
          eventType: 'operational'
        }
      });
      this.setState({
        errorCaptured: true,
        fallbackMessage: this.getFallbackMessage(errorMessages.unhandledErrorMessage)
      });
    }
  }
  render() {
    if (this.shouldRecover()) {
      return /*#__PURE__*/React.createElement(UnhandledErrorScreen, {
        text: this.state.fallbackMessage,
        onCancel: this.props.onCloseFallback
      });
    }
    return this.props.children;
  }
}